<template>
	<div class="main" v-loading.fullscreen="isLoad" router element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>店铺装修</el-breadcrumb-item>
			<el-breadcrumb-item>模板设置</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="tabar">
			<div class="tabar-title">模板类型</div>
			<div class="tabar-list">
				<div :class="numActive == index? 'tabar-list-select': '' " @click="clickTabar(index)" v-for="(list,index) in tabarList">{{list}}</div>
			</div>
		</div>
		<div class="tabar">
			<div class="tabar-title">模板分类</div>
			<div class="tabar-list">
				<div class="tabar-list-select">全部类型</div>
				<div>未分类</div>
			</div>
		</div>
		<div class="template-list">
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
			<div class="template">
				<img src="../../assets/logo.png">
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
				return {
					item: {},
					isLoad: false,
					numActive: 0,
					tabarList:["全部类型","自定义页面","商城首页","会员中心"]
				}
			},
			created() {
				// this.loadItem()
			},
			methods: {
				clickTabar(index){
					console.log(index);
					this.numActive = index
				}
			}
	}
</script>

<style scoped="scoped">
	.bnone {
		margin-bottom: 10px;
	}

	.tabar {
		display: flex;
	}

	.tabar div {
		padding: 8px;
	}

	.tabar .tabar-title {
		display: flex;
		align-items: center;
	}

	.tabar .tabar-list {
		display: flex;
	}

	.tabar-list div {
		background-color: #FFFFFF;
		border: 1px solid #d5d5d5;
		margin-left: 6px;
	}
	.tabar-list div:hover{
		cursor:pointer;
	}

	.tabar-list .tabar-list-select {
		background-color: #409EFF;
		color: white;
	}

	.template-list {
		margin-top: 14px;
		margin-left: 16px;
		display: flex;
		flex-wrap: wrap;
	}

	.template-list .template {
		box-sizing: border-box;
		padding: 8px;
		width: 216px;
		height: 350px;
		border: 1px solid #d5d5d5;
		margin-right: 16px;
		margin-bottom: 10px;
	}

	.template img {
		width: 100%;
	}
</style>
